import { CloudOff, RotateCw } from 'lucide-react';
import ErrorState from './ErrorState';
import { PRIMARY_BUTTON, SECONDARY_BUTTON, MICRO_LABEL } from '../constants';

const ServerError = ({ message, onRetry, onChooseAnother }) => (
    <ErrorState
        icon={CloudOff}
        title="Simulation failed"
        actions={
            <>
                <button type="button" onClick={onRetry} className={PRIMARY_BUTTON}>
                    <RotateCw className="w-3.5 h-3.5" />
                    <span className={MICRO_LABEL}>Retry</span>
                </button>
                <button type="button" onClick={onChooseAnother} className={SECONDARY_BUTTON}>
                    <span className={MICRO_LABEL}>Choose Another Photo</span>
                </button>
            </>
        }
    >
        <p>{message}</p>
    </ErrorState>
);

export default ServerError;
